import { Component } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { CookieConsentService, CookiePreferences } from '../../../core/services/cookie-consent/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent-bottom-sheet',
  templateUrl: './cookie-consent-bottom-sheet.component.html',
  styleUrls: ['./cookie-consent-bottom-sheet.component.scss']
})
export class CookieConsentBottomSheetComponent {
  showCustomize = false;
  preferences: CookiePreferences = {
    necessary: true,
    analytics: true,
    marketing: true
  };

  constructor(
    private bottomSheetRef: MatBottomSheetRef<CookieConsentBottomSheetComponent>,
    private cookieConsent: CookieConsentService
  ) {
    const saved = this.cookieConsent.getPreferences();
    if (saved) {
      this.preferences = { ...saved };
    }
  }

  accept(): void {
    this.cookieConsent.accept();
    this.bottomSheetRef.dismiss();
  }

  reject(): void {
    this.cookieConsent.reject();
    this.bottomSheetRef.dismiss();
  }

  openCustomize(): void {
    this.showCustomize = true;
  }

  saveCustomized(): void {
    this.cookieConsent.saveCustomized(this.preferences);
    this.bottomSheetRef.dismiss();
  }

  back(): void {
    this.showCustomize = false;
  }

  close(): void {
    this.bottomSheetRef.dismiss();
  }
}
